export default "__VITE_ASSET__CHfNr1GW__"